import Component from '../abstracts/Component';
import OnDemandLiveRegion from '../utils/OnDemandLiveRegion';

export default class CartV2Component extends Component {
  get SELECTORS() {
    return {
      cart: '[data-cart-wrapper]',
      cartAlertBox: '[data-jsnotification]',
      cartAlert: '[data-jsnotification] .js-cart-alert', // cannot do with data-
      cartExceeding: '[data-cart-exceeding]',
      cartError: '[data-cart-error]',
      qtyBtn: '[data-qty]',
      qtyBtnMore: '[data-qty-more]',
      qtyBtnLess: '[data-qty-less]',
      //
      shippingRadios: '[data-shipping-method] input[type=radio]',
      shippingRadiosBox: '[data-shipping-method]',
      //
      proceedBtn: '[data-proceed-btn]',
      deliveryMethodInputChecked: '[data-delivery-method]:checked',
      //
      storeLocator: '[data-storelocator]',
      storeLocatorErrorMessage: '[data-storelocator-error]',
      storesList: '[data-storelocator-results]',
      storeInput: `[data-storelocator] input[name='deliveryMethodStore']`,
      storeCard: '[data-store-item]',
      //
      shipmentBoxes: '[data-cart-shipping-methods]',
      cartTotals: '[data-cart-total-items]',
    };
  }

  get CLASSES() {
    return {
      buttonLoading: '--loading',
      checked: 'checked',
      error: 'error',
      lastItem: 'js-cart-remove-last',
      disabled: 'disabled',
      show: 'show',
      active: 'active',
      hidden: '--hidden',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.cart = this.$component.querySelector(this.SELECTORS.cart);
    this.cartAlert = this.$component.querySelector(this.SELECTORS.cartAlert);
    this.cartAlertBox = this.$component.querySelector(this.SELECTORS.cartAlertBox);
    this.cartExceeding = this.$component.querySelector(this.SELECTORS.cartExceeding);
    // quantity management
    this.quantityBoxes = this.$component.querySelectorAll(this.SELECTORS.qtyBtn);
    // delivery management
    this.shipmentBoxes = this.$component.querySelector(this.SELECTORS.shipmentBoxes);
    this.shippingRadios = this.$component.querySelectorAll(this.SELECTORS.shippingRadios);
    this.storeLocator = this.$component.querySelector(this.SELECTORS.storeLocator);
    this.storesList = this.$component.querySelector(this.SELECTORS.storesList);
    this.storeLocatorErrorMessage = this.$component.querySelector(this.SELECTORS.storeLocatorErrorMessage);
    this.cartTotals = this.$component.querySelectorAll(this.SELECTORS.cartTotals);
  }

  cartAlerts() {
    // cart alerts
    if (this.cartAlert !== null && this.cartAlertBox !== null) {
      this.cartAlertBox.classList.add(this.CLASSES.show);
      setTimeout(() => {
        this.cartAlertBox.classList.remove(this.CLASSES.show);
      }, 3000);
    }
  }

  cartExceedingAlert() {
    if (this.cartExceeding !== null) {
      this.$emit(this.$customEvents.MODAL_EVENTS.show, {
        unsafeContent: this.cartExceeding.innerHTML,
      });
    }
  }

  // quantity management
  quantityManager() {
    // ctx
    let ctx = this;
    // quantity box looop
    this.quantityBoxes.forEach(quantityBox => {
      let addBtn = quantityBox.querySelector(this.SELECTORS.qtyBtnMore);
      let removeBtn = quantityBox.querySelector(this.SELECTORS.qtyBtnLess);
      // bind btns
      addBtn?.addEventListener('click', e => {
        if (!e.target.classList.contains(this.CLASSES.disabled)) {
          e.target.classList.add(this.CLASSES.disabled);
          
          // save focus only for keyboard navigation
          if (window.__lastInteractionWasKeyboard) {
            const focusId = addBtn.dataset.focusId;
            if (focusId) sessionStorage.setItem('cartFocusId', focusId);
          }
          
          // save new quantity for screen reader announcement
          const newQty = parseInt(quantityBox.dataset.qty, 10) + 1;
          sessionStorage.setItem('cartQtyChanged', newQty);
          
          // update quantity
          ctx.updateQuantity(quantityBox, newQty);
        }
      });
      //
      removeBtn?.addEventListener('click', e => {
        // btn to target , take care i click on the span
        let btn = e.target.localName == 'i' ? e.target.parentNode : e.target;
        if (
          parseInt(quantityBox.dataset.qty, 10) > 0 &&
          !btn.classList.contains(this.CLASSES.lastItem) &&
          !e.target.classList.contains(this.CLASSES.disabled)
        ) {
          e.target.classList.add(this.CLASSES.disabled);
          
          // save focus only for keyboard navigation
          if (window.__lastInteractionWasKeyboard) {
            const focusId = btn.dataset.focusId;
            if (focusId) sessionStorage.setItem('cartFocusId', focusId);
          }
          
          // save new quantity for screen reader announcement
          const newQty = parseInt(quantityBox.dataset.qty, 10) - 1;
          sessionStorage.setItem('cartQtyChanged', newQty);
          
          // update quantity
          ctx.updateQuantity(quantityBox, newQty);
        }
      });
    });
  }

  updateQuantity(box,qty) {
    // check
    if (box === null) return false;
    // update url
    let updateQtyUrl = this.cart.dataset.updateQtyUrl;
    // set attribute data
    box.dataset.qty = qty;
    // go update quantity
    location.href = updateQtyUrl+'&entryNumber='+box.dataset.entryNumber+'&qty='+qty;
  }

  scrollIfError() {
    if ($('#cart-authentication').data('checkoutloginError')) {
      window.scrollTo(
        0,
        document.querySelector('#cart-authentication').scrollHeight + 500
      );
    }
  }

  // CLICK & COLLECT
  shippingMethodsManage() {
    // check
    if (this.shippingRadios === null) return false;
    // clicks on radio
    this.shippingRadios.forEach(checkbox => {
      // if is
      let isClickAndCollectCheckbox = checkbox.id.includes('Click-and-Collect');
      // listen to the click
      checkbox.addEventListener('change', event => {
        // hide/show store locator
        this.showOrHideStoreLocator(!isClickAndCollectCheckbox);
        // update delivery method if not click and collect
        this.updateDeliveryMethod(event);
        // change method class
        let checboxBoxChecked = document.querySelector(this.SELECTORS.shippingRadiosBox + '.' + this.CLASSES.checked);
        let checboxBox = checkbox.closest(this.SELECTORS.shippingRadiosBox);
        // remove class from checked
        checboxBoxChecked.classList.remove(this.CLASSES.checked);
        // add class to selected
        checboxBox.classList.add(this.CLASSES.checked);
      });
    });
  }

  // show or hide store locator
  showOrHideStoreLocator(hide) {
    if (this.storeLocator !== null) {
      if (hide) {
        this.storeLocator.classList.add('--hidden');
      } else {
        this.storeLocator.classList.remove('--hidden');
      }
    }
  }

  // update delivery method by input ajax call to update delivery method
  updateDeliveryMethod(event) {

    // CHECK IF IS OK
    // let stores = $('.ma_sl-store-item input');
    // stores.each((index, store) => {
    //   store.checked = false;
    // });

    let input = event.currentTarget
    // remove error message in C&C section
    this.storeLocatorErrorMessage.classList.add(this.CLASSES.hidden);
    this.shipmentBoxes.classList.remove(this.CLASSES.error);
    let deliveryMethod = input.value;
    let proceedBtn = this.$component.querySelector(this.SELECTORS.proceedBtn);
    proceedBtn.setAttribute("disabled","disabled");

    let selectedStore = '';
    if (input.getAttribute('data-click-collect')) {
      selectedStore = input.getAttribute('id');
    }

    if(!selectedStore){
      const storesInputs = this.$component.querySelectorAll(this.SELECTORS.storeInput);
      storesInputs.forEach(input => {
        if(input?.checked){
          selectedStore = input.getAttribute('id');
        }
      })
    }

    const params = new URLSearchParams({
      'set-delivery-mode': 'updateDelivery',
      code: deliveryMethod,
      selectedStore: selectedStore,
    });

    const url = `${document.location.origin}${document.location.pathname}?${params}`;
    // go ajax
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(res => {
        return res.text();
      })
      .then(data => {
        // console.log('[CartController]fetch done:',deliveryMethod,selectedStore);
        let html = new DOMParser().parseFromString(data, 'text/html');
        // Searching errors
        let isStoreNotSelectedError = html.querySelector(this.SELECTORS.cartError) !== null;
        // console.log('isStoreNotSelectedError: ' + isStoreNotSelectedError);
        // Showing errors in C&C section
        if (isStoreNotSelectedError) {
          // console.log('[CartController] Showing isStoreNotSelectedError');
          this.storeLocatorErrorMessage.classList.remove(this.CLASSES.hidden);
          this.shipmentBoxes.classList.add(this.CLASSES.error);
        }
        // there are 2 totals, mobile and desktop
        let cartResponse = html.querySelector(this.SELECTORS.cartTotals);
        if (cartResponse && this.cartTotals !== null) {
          this.cartTotals.forEach(cartTotalBox => {
            cartTotalBox.classList.add('transparent');
            setTimeout(function (){
              cartTotalBox.innerHTML = cartResponse.innerHTML;
              cartTotalBox.classList.remove('transparent');
            },400);
          });
        }
      }).finally(() => {

        // enable cta
        proceedBtn.classList.remove(this.CLASSES.disabled);
        proceedBtn.removeAttribute("disabled");
      })
  }

  clickCollectStoreSelection() {
    // ctx
    let ctx = this;
    // click collect select store
    let storesInputs = this.$component.querySelectorAll(this.SELECTORS.storeInput);
    // check
    if (storesInputs === null) return false;
    // vars
    let proceedBtn = this.$component.querySelector(this.SELECTORS.proceedBtn);
    // loop
    storesInputs.forEach( input => {
      input.addEventListener('change', (event) => {
        // disable cta
        proceedBtn.classList.add(ctx.CLASSES.disabled);
        // error reset
        ctx.storeLocatorErrorMessage.classList.add(ctx.CLASSES.hidden);
        ctx.shipmentBoxes.classList.remove(ctx.CLASSES.error);
        // remove active
        let stores = ctx.storesList.querySelectorAll(ctx.SELECTORS.storeCard);
        if (stores !== null) {
          stores.forEach(store => {
            store.classList.remove(ctx.CLASSES.active);
          });
        }
        // add active
        if (input.checked) {
          let parentStoreItem = input.closest(ctx.SELECTORS.storeCard); // Find the closest .js-store-item parent
          if (parentStoreItem) {
            parentStoreItem.classList.add(ctx.CLASSES.active);
          }
        }
        // submit selection method delivery change
        this.updateDeliveryMethod(event);
      });
    });
  }

  restoreFocus() {
    const focusId = sessionStorage.getItem('cartFocusId');
    if (!focusId) return;

    const candidates = [...document.querySelectorAll(`[data-focus-id="${focusId}"]`)];
    const focusTarget = candidates.find(el => el.offsetParent !== null);

    if (focusTarget) {
      focusTarget.focus();
      focusTarget.setAttribute("data-focused", "true");
      sessionStorage.removeItem('cartFocusId');
    }
  }

  announceQuantityUpdate() {
    const newQty = sessionStorage.getItem('cartQtyChanged');
    const focusId = sessionStorage.getItem('cartFocusId');
    
    if (!newQty) {
      // Clean up if quantity wasn't changed
      sessionStorage.removeItem('cartQtyChanged');
      return;
    }

    // Find the quantity box to get the translated message
    let quantityBox = null;

    if (focusId) {
      // Find the specific button that was clicked using its focus ID
      const candidates = [...document.querySelectorAll(`[data-focus-id="${focusId}"]`)];
      const button = candidates.find(el => el.offsetParent !== null);
      
      if (button) {
        quantityBox = button.closest('.js-qty');
      }
    } else {
      // Fallback: find the first visible quantity box
      quantityBox = document.querySelector('.js-qty');
    }
    
    if (quantityBox) {
      // Get the update message from the quantity box's data attribute
      const updateMsg = quantityBox.dataset.updateMessage || 'Quantità aggiornata';
      const announcement = `${updateMsg}. Quantità: ${newQty}`;
      
      // Use OnDemandLiveRegion for reliable screen reader announcement
      const liveRegion = new OnDemandLiveRegion({
        level: 'assertive',
        parent: 'body',
        idPrefix: 'cart-qty-announce-',
        delay: 100
      });
      
      liveRegion.sayMessage(announcement);
    }

    // Always clean up the quantity change flag
    sessionStorage.removeItem('cartQtyChanged');
  }

  bindEvents() {
    window.__lastInteractionWasKeyboard = false;

    document.addEventListener('keydown', (e) => {
      if (!['Shift', 'Alt', 'Meta', 'Control'].includes(e.key)) {
        window.__lastInteractionWasKeyboard = true;
      }
    });

    document.addEventListener('mousedown', () => {
      window.__lastInteractionWasKeyboard = false;
    });

    document.addEventListener('click', () => {
      const focusedElement = document.querySelector('[data-focused="true"]');
      if (focusedElement) {
        focusedElement.removeAttribute('data-focused');
      }
    });

    document.addEventListener('keydown', () => {
      const focusedElement = document.querySelector('[data-focused="true"]');
      if (focusedElement) {
        focusedElement.removeAttribute('data-focused');
      }
    });

    this.announceQuantityUpdate();
    this.restoreFocus();

    // on show results
    this.$on(this.$customEvents.O2O.ccStoresShowResults, e => {
      // function to listen radio change
      this.clickCollectStoreSelection(e);
    });

    let isStoreNotSelectedError = this.$component.querySelector('.store-not-selected-flag') !== null;
     //console.log('isStoreNotSelectedError: ' + isStoreNotSelectedError);
    // Showing errors in C&C section
    if (isStoreNotSelectedError) {
      //console.log('[CartController] Showing isStoreNotSelectedError');
      this.storeLocatorErrorMessage.classList.remove(this.CLASSES.hidden);
      this.shipmentBoxes.classList.add(this.CLASSES.error);
    }
  }

  checkSubmitForm() {
    // vars
    let proceedBtn = this.$component.querySelector(this.SELECTORS.proceedBtn);
    let storeLocator = this.$component.querySelector(this.SELECTORS.storeLocator);
    // check
    if (proceedBtn === null || typeof storeLocator === null) return false;
    //
    proceedBtn.addEventListener("click", e => {
      e.preventDefault();
      // added loading class
      e.currentTarget.classList.add(this.CLASSES.buttonLoading);
      // after clicking, I disable it
      e.currentTarget.setAttribute("disabled", "");
      // take the input live
      let deliveryMethodInputChecked = document.querySelector(this.SELECTORS.deliveryMethodInputChecked);
      // check if c&c is selected
      if (deliveryMethodInputChecked !== null && deliveryMethodInputChecked.id.includes("clickAndCollect") ) {
        // check if there is a store selected
        let storeSelected = storeLocator.querySelector('input:checked');
        if (storeSelected !== null && typeof storeSelected !== 'undefined') {
          this.storeLocatorErrorMessage.classList.add(this.CLASSES.hidden);
          window.location.href = proceedBtn.href;
        } else {
          e.currentTarget.classList.remove(this.CLASSES.buttonLoading);
          e.currentTarget.removeAttribute("disabled");
          // show error
          this.storeLocatorErrorMessage.classList.remove(this.CLASSES.hidden);
        }
      } else {
        // no c&c , let's go
        window.location.href = proceedBtn.href;
        // reset if i changed method
        this.storeLocatorErrorMessage.classList.add(this.CLASSES.hidden);
      }
    });
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
    //
    this.cartAlerts();
    //
    this.cartExceedingAlert();
    //
    this.quantityManager();
    //
    this.scrollIfError();
    //
    this.checkSubmitForm();
    //
    this.shippingMethodsManage();

    // scrollbar support
    let isSelectorSupported = CSS.supports('selector(::-webkit-scrollbar)');
    if (!isSelectorSupported) {
      this.storesList.style.scrollbarWidth = 'thin';
      this.storesList.style.scrollbarColor = '#656364 transparent';
    }
  }
}
